import React from 'react';
import { motion } from 'framer-motion';

const ProductOverview = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                delayChildren: 0.1
            }
        }
    };

    const fadeUpVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    };

    return (
        <section className="w-full bg-white py-[60px] md:py-[100px] overflow-hidden">
            <div className="max-w-[1440px] mx-auto lg:px-[80px] px-[20px]">
                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    className="flex flex-col lg:flex-row gap-[32px] md:gap-[40px] items-start"
                >
                    <motion.div
                        variants={fadeUpVariants} className="max-w-[249px] w-full"
                    >
                        <h2 className="text-[20px] md:text-[30px] font-sora font-[600] text-[#01386A] leading-[1.2] tracking-tight">
                            Product <br className="hidden md:block" /> Overview
                        </h2>
                    </motion.div>

                    {/* Middle Column: Abstract Image */}
                    <motion.div
                        variants={fadeUpVariants}
                        className="w-full max-w-[418px] bg-gray-50 overflow-hidden"
                    >
                        <img
                            src="/assets/glodesk/img6.png"
                            alt="Product Overview Graphic"
                            className="w-full h-full object-cover select-none pointer-events-none"
                        />
                    </motion.div>

                    {/* Right Column: Description Text */}
                    <motion.div
                        variants={fadeUpVariants}
                        className="max-w-[424px] w-full ml-auto"
                    >
                        <p className="text-[#49577A] text-[14px] sm:text-[16px] font-graphik font-[500] leading-[1.6]">
                            Glokode is a simple, modern ERP designed to make business operations easier and less stressful. It brings everything inventory, field work, orders, services, and team collaboration, into one place. With smart AI support, it helps you stay organized, save time, and make better everyday business decisions.
                        </p>
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
};

export default ProductOverview;